import { useState, useEffect } from 'react';
import axios from 'axios';

const API =  process.env.REACT_APP_API_URL;

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/customers`).then(res => setCustomers(res.data)).catch(() => {});
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Customers</h2>
      <table className="w-full text-sm">
        <thead><tr className="bg-gray-100"><th className="p-2 text-left">Name</th><th className="p-2 text-left">Email</th><th className="p-2 text-left">Role</th></tr></thead>
        <tbody>
          {customers.map(c => (
            <tr key={c.id} className="border-b"><td className="p-2">{c.name}</td><td className="p-2">{c.email}</td><td className="p-2">{c.role}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}